<template>
  <div class="home">
    <el-container class="home_container">
      <!-- 头部 -->
      <div style="height: 800px" class="header clearfix">
        <div>
          <div v-show="showCarousel">
            <el-carousel trigger="click" height="800px" arrow="always">
              <el-carousel-item v-for="item in carouselLs" :key="item">
                <img
                  style="width: 100%; height: 100%; overflow-y: none"
                  v-lazy="item"
                />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div v-show="!showCarousel">
            <!-- 懒加载图片 -->
            <img v-lazy="bannerSrc" alt="banner" style="width: 100%" />
          </div>
        </div>
        <div class="nav clearfix">
          <div class="left fl clearfix">
            <img src="../../static/image/logo-3.png" alt="" style="width:331px;height:61px;" />
          </div>
          <div class="right fr clearfix">
            <ul>
              <li>
                <a href="/#/" @click="showCarousel = true">首页</a>
              </li>
              <li v-for="(item, key) in topLink" :key="key">
                <a href="#" @click="toNext(item)">{{ item.title }}</a>
                <i :class="item.icon"></i>
                <div class="nav_top">
                  <div class="navDetail">
                    <div class="triangle"></div>
                    <div
                      class="item"
                      v-for="(list, index) in item.secondTitle"
                      :key="index"
                      @click="toSecondNext(item, index)"
                    >
                      <!-- @click="goAnchor('#anchor')" -->
                      <div style="cursor: pointer">{{ list }}</div>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <a href="#" @click="toNext({ title: '公告栏' })">公告栏</a>
              </li>
              <li>
                <a @click="complaintClick">投诉举报</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--主体-->
      <div
        ref="elMain"
        id="anchor"
        class="main_container"
        style="padding: 0 !important"
      >
        <router-view></router-view>
      </div>
      <!-- 底部 -->
      <el-footer class="footer clearfix" style="height: 400px">
        <div class="footer_container clearfix">
          <dl v-for="(value, index) in topLink" :key="index">
            <dt>
              <a class="" href="#" @click.stop="toNext(value)">{{
                value.title
              }}</a>
            </dt>
            <dt v-for="(list, key) in value.secondTitle" :key="key">
              <div
                href="#"
                style="cursor: pointer"
                @click.stop="toSecondNext(value, key)"
              >
                {{ list }}
              </div>
            </dt>
          </dl>
          <div class="right clearfix">
            <span class="item">
              <p>扫码关注官微</p>
              <img src="../../static/image/code_01.png" alt="" />
            </span>
            <span class="item">
              <p>Android端下载</p>
              <img src="../../static/image/code_02.png" alt="" />
            </span>
            <span class="item">
              <p>iOS端下载</p>
              <img src="../../static/image/code_03.png" alt="" />
            </span>
          </div>
        </div>
        <div class="basisInfo">
          <span>服务热线： 400-894-5099</span>
          <span class="line">|</span>
          <span>企业邮箱：hwason@hwason.cn</span>
          <span class="line">|</span>
          <span
            >企业地址：南京市江北新区新锦湖路3-1号中丹生态生命科学产业园二期C座4层、D座4层</span
          >
          <span class="line">|</span>
          <!-- <span class="complaint" @click="complaintClick">投诉举报</span>
          <span class="line">|</span> -->
          <a href="#">
            <router-link to="/stuffEnter">
              <span class="entrance" @click="showCarousel = true"
                >员工入口 >></span
              >
            </router-link>
          </a>
        </div>
        <p style="font-size: 14px;text-align: center;margin: 30px 0 5px 0;">
          <img src="../../static/image/beian.png" alt=""  style="height: 14px;width:14px;"/>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32011202001150" rel="noreferrer" target="_blank">       
            苏公网安备32011202001150号
          </a>
        </p>
        <p class="copyRight">
          @版权所有：南京江河华晟医学科技有限公司 备案号：
          <a href="http://beian.miit.gov.cn">
            <u>苏ICP备17019734号-1</u>
          </a>
        </p>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      showCarousel: true,
      bannerSrc: '',
      topLink: [
        {
          title: '关于华晟',
          icon: 'el-icon-arrow-down',
          secondTitle: [
            '公司介绍',
            '实验室介绍',
            '企业文化',
            '合作伙伴',
            '发展历程',
          ],
        },
        {
          title: '质量管理',
          icon: 'el-icon-arrow-down',
          secondTitle: ['高质量管理', '质量控制'],
        },
        {
          title: '新闻动态',
          icon: 'el-icon-arrow-down',
          secondTitle: ['公司新闻', '行业资讯'],
        },
        {
          title: '产品与服务',
          icon: 'el-icon-arrow-down',
          secondTitle: ['江河云诊所', '微 E 检', 'E 晟宝'],
        },
        {
          title: '联系我们',
          icon: 'el-icon-arrow-down',
          secondTitle: ['公司地址', '员工风采', '招聘信息', '开票信息'],
        },
      ],
      carouselLs: [
        require('../assets/banner01.jpg'),
        require('../assets/banner02.jpg'),
        require('../assets/banner03.jpg'),
        require('../assets/banner04-1.jpg'),
      ],
    }
  },
  methods: {
    // 新增投诉举报按钮
    complaintClick() {
      window.open('https://www.wenjuan.com/s/UZBZJvuN01/', '_blank')
    },
    // 导航连接跳转
    toNext(item) {
      const vm = this
      // console.log(item)
      let url = ''
      if (item.title === '关于华晟') {
        vm.showCarousel = false
        vm.bannerSrc = require('../assets/banner04.jpg')
        url = '/aboutUs'
      }
      if (item.title === '质量管理') {
        vm.showCarousel = false
        vm.bannerSrc = require('../assets/banner05.jpg')
        url = '/quality'
      }
      if (item.title === '新闻动态') {
        vm.showCarousel = false
        vm.bannerSrc = require('../assets/banner06.jpg')
        url = '/news'
      }
      if (item.title === '产品与服务') {
        vm.showCarousel = false
        vm.bannerSrc = require('../assets/banner07.jpg')
        url = '/product'
      }
      if (item.title === '联系我们') {
        vm.showCarousel = false
        vm.bannerSrc = require('../assets/banner08.jpg')
        url = '/contact'
      }
      if (item.title === '公告栏') {
        vm.showCarousel = false
        vm.bannerSrc = require('../assets/banner09.jpg')
        // console.log(1111)
        url = '/notice'
      }

      vm.$router.push({ path: url })
    },

    // 二级导航跳转
    toSecondNext(item, index) {
      const vm = this
      let url = ''
      if (item.title === '关于华晟') {
        vm.showCarousel = false
        vm.bannerSrc = require('../assets/banner04.jpg')
        url = '/aboutUs'
      } else if (item.title === '质量管理') {
        vm.showCarousel = false
        vm.bannerSrc = require('../assets/banner05.jpg')
        url = '/quality'
      } else if (item.title === '新闻动态') {
        vm.showCarousel = false
        vm.bannerSrc = require('../assets/banner06.jpg')
        url = '/news'
      } else if (item.title === '产品与服务') {
        vm.showCarousel = false
        vm.bannerSrc = require('../assets/banner07.jpg')
        url = '/product'
      } else if (item.title === '联系我们') {
        vm.showCarousel = false
        vm.bannerSrc = require('../assets/banner08.jpg')
        url = '/contact'
      } else if (item.title === '公告栏') {
        vm.showCarousel = false
        vm.bannerSrc = require('../assets/banner09.jpg')
        url = '/notice'
      } else {
        vm.showCarousel = true
      }
      vm.$router.push({ path: url, query: { activeName: index } })
    },

    // goAnchor(selector) {
    //   console.log('锚点定位', selector)
    //   var anchor = this.$el.querySelector(selector)
    //   document.body.scrollTop = anchor.offsetTop // chrome
    //   document.documentElement.scrollTop = anchor.offsetTop // firefox
    // }
  },
}
</script>

<style lang="scss" scoped>
img[lazy='loading'] {
  display: block;
  width: 100% !important;
  height: 100% !important;
  margin: 0 auto;
}
.home {
  min-width: 1400px;
  .header {
    // padding: 14px 8% 0 8%;
    width: 100%;
    height: 600px;
    position: relative;
    overflow: hidden;
    .nav {
      position: absolute;
      top: 20px;
      left: 8%;
      z-index: 100;
      width: 100%;
      .right {
        margin-right: 16%;

        ul {
          height: 60px;
          line-height: 60px;
          li {
            float: left;
            margin-right: 50px;
            position: relative;
            &:hover .nav_top {
              height: 285px;
            }
            .nav_top {
              position: absolute;
              height: 0;
              overflow: hidden;
              transition: all 0.8s;
              .navDetail {
                position: relative;
                top: 12px;
                background-color: #fff;
                width: 239px;
                padding: 0 0 14px 14px;
                .item {
                  height: 40px;
                  font-size: 14px;
                  a:hover {
                    color: #0068b7f2;
                  }
                }
                .triangle {
                  overflow: auto;
                  position: absolute;
                  left: 26px;
                  top: -13px;
                  width: 0;
                  height: 0;
                  border-right: 14px solid transparent;
                  border-left: 14px solid transparent;
                  border-bottom: 14px solid #fff;
                }
                a {
                  color: #000;
                }
              }
            }
            a {
              color: #fff;
              cursor: pointer;
            }
            i {
              color: #fff;
              cursor: pointer;
              padding-left: 10px;
            }
          }
        }
      }
    }
  }
  .footer {
    padding: 0 8%;
    padding-top: 90px;
    background-color: #e5e5e5;
    position: relative;
    .footer_container {
      padding: 0 4%;
      dl {
        float: left;
        width: 11%;
        dt {
          height: 28px;
          line-height: 28px;
          a {
            color: #666666;
          }
          &:first-child {
            height: 34px;
            line-height: 34px;
            font-weight: 700;
            a {
              color: #333333;
            }
          }
        }
      }
      .right {
        position: absolute;
        right: 12%;
        top: 73px;
        .item {
          float: left;
          padding-left: 10px;
          p {
            text-align: center;
            height: 30px;
            line-height: 30px;
          }
          img {
            // border: 1px dashed #000;
          }
        }
      }
    }
    .basisInfo {
      text-align: center;
      padding-top: 47px;
      color: #333333;
      border-bottom: 1px solid #999999;
      .line {
        color: #666666;
        padding: 0 12px;
      }
      .entrance {
        padding: 2px 8px;
        width: 94px;
        background-color: #ff5917;
        color: #fff;
        font-size: 14px;
        height: 70px;
        line-height: 70px;
      }
    }
    .copyRight,
    a {
      text-align: center;
      padding-bottom:10px;
      color: #000;
    }
  }
  .el-main {
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue